// ForgotPassword.js
import React, { useState } from "react";
import axios from "axios"; // You can also use fetch if you prefer
import { API_URL } from "../constants";
import { ToastContainer, toast } from "react-toastify";
import { FaSpinner, FaLock, FaUserCircle } from "react-icons/fa";
import nestlogo from "../assets/APPROVED_NEST TYPO DARK.svg";
import { useNavigate } from "react-router-dom";


const ForgotPassword = () => {
  const navigate = useNavigate();
  // State for email and form submission status
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");
  // Handle email change
  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    setError("");
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitted(true);
    // Basic email validation (could be expanded)
    if (!email || !/\S+@\S+\.\S+/.test(email)) {
      setError("Please enter a valid email address");
      setSubmitted(false);
      return;
    }

    try {
      // Clear previous error and message
      setError("");

      // Call API to send reset password link
      const response = await axios.post(`${API_URL}password/email`, { email });

      // On success, show message
      if (response?.status === 200) {
        toast.success("Password reset link has been sent to your email.");
        setEmail("");
      }
      setSubmitted(false);
        setTimeout(() => {
      navigate("/");
    }, 2000);
    } catch (err) {
      // Handle API error
      setError("Unable to send password reset link. Please try again later.");
      setSubmitted(false);
      // toast.error(
      //   "Unable to send password reset link. Please try again later."
      // );
    }
  };

  return (
    <>
      <div className="nest-login-page">
        <div className="container">
              <div className="text-center logo-mobile-only">
                 <img src={nestlogo} className="logoImgLogin" alt="Logo" /> 
                </div>
          <div class="row">
            <div class="col-12 col-md-6 d-flex justify-content-center align-items-center">
              <div class="login-container">
                <FaLock className="lock-icon"></FaLock>
                <br />
                <strong class="card-title">Forgot Password</strong>
                <form onSubmit={handleSubmit} class="login-form">
                  <p className="mb-1">Please Enter Your Email</p>
                  <div class="login-form-group">
                    <span class="fa fa-user-o form-control-icon login-input-icon"></span>
                    <input
                      type="text"
                      onChange={handleEmailChange}
                      className={
                        error.email
                          ? "form-control login-form-control invalids"
                          : "form-control login-form-control"
                      }
                      value={email}
                      id="email"
                      name="email"
                      placeholder="Email"
                      style={{
                        backgroundColor: "transparent",
                        color: "#66c4de",
                        WebkitTextFillColor: "#66c4de",
                        // boxShadow: "0 0 0 30px #143952 inset",
                        transition: "background-color 5000s ease-in-out 0s",
                      }}
                    />
                  </div>
                  {error && (
                    <p className="login-error">
                      {error}
                    </p>
                  )}
                  <div>
                    <button
                      disabled={submitted ? true : false}
                      type="submit"
                      // className="login-custom"
                      style={{
                        width: "70%",
                        padding: "10px",
                        borderRadius: "30px",
                        background: "#2BB2FF",
                        color: "white",
                        border: "none",
                        fontWeight: "bold",
                        marginTop: "20px",
                      }}
                    >
                      {submitted ? (
                        <FaSpinner class="sm-spinner" />
                      ) : (
                        "SEND RESET LINK"
                      )}
                    </button>
                  </div>
                </form>
                <ToastContainer
                  position="top-right"
                  autoClose={5000}
                  hideProgressBar={false}
                  newestOnTop={false}
                  closeOnClick
                  rtl={false}
                  pauseOnFocusLoss
                  draggable
                  pauseOnHover
                />
              </div>
            </div>
            {/* <div class="col-sm-6"></div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgotPassword;
